import Swiper from "swiper/bundle"; // Import Swiper from the installed package

// Initialize and export the function
export function initPartnersSlider() {
  const partnersSlider = document.querySelector(".our-partners-slider .swiper");
  if (partnersSlider) {
    new Swiper(partnersSlider, {
      // Optional parameters
      loop: true,
      speed: 800,
      spaceBetween: 30,

      // Autoplay
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },

      // Responsive breakpoints
      slidesPerView: 1,
      breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        // when window width is >= 992px
        992: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 4,
          spaceBetween: 50,
        },
      },

      // If we need pagination
      pagination: {
        el: ".partners-slider-pagination",
        clickable: true,
      },

      // If we need navigation buttons
      navigation: {
        nextEl: ".our-partners-slider .swiper-button-next",
        prevEl: ".our-partners-slider .swiper-button-prev",
      },
    });
  }
}
